// External Libraries
import * as React from "react";

// UITK
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSecondaryButton } from "uitk-react-button";
import { classNames } from "uitk-react-utils";

// Utils
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";

// Types
import { HotelAffinityFilterProps } from "src/components/flexComponents/Hotels/typings";

// Components
import { useHotelsContext } from "components/flexComponents/Hotels/components/HotelsContext";

const ButtonTracked = FlexClickTracker(UitkSecondaryButton);

/**
 * HotelAffinityFilters: Component to render a list of filters
 * @param {HotelAffinityFilterProps} props
 */
export const HotelAffinityFilters: React.FC<HotelAffinityFilterProps> = ({ filters, className }) => {
  const { flexTemplateNode, model } = useHotelsContext();
  const moduleName = flexTemplateNode.options.flexComponentName;

  return (
    <UitkLayoutFlex
      space="three"
      wrap="wrap"
      justifyContent="center"
      className={classNames("all-t-margin-two", className)}
    >
      {filters.map((pill) => (
        <UitkLayoutFlexItem key={pill.key}>
          <ButtonTracked
            moduleName={moduleName}
            text={pill.label}
            href={model.seeAllLink + pill.queryFilter}
            rfrr={`HotelAffinityFilter.actionLink.${pill.label}`}
            data-testid="affinity-filters"
          />
        </UitkLayoutFlexItem>
      ))}
    </UitkLayoutFlex>
  );
};

HotelAffinityFilters.displayName = "HotelAffinityFilters";
